import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Helpers
import { getURLSegment } from '../../helpers/helpers.js';

const TallyLoader = observer(class TallyLoader extends React.Component {
  componentWillMount() {
    const { loadingCalls, tallySteps } = this.props.store.SessionStore;

    const steps = [];

    tallySteps.forEach(step => {
      const stepObj = {
        title: step,
        started: loadingCalls.indexOf(step) > -1 ? true : false,
        completed: false,
        success: false
      }

      steps.push(stepObj)
    });

    this.state = {
      steps: steps,
      total: tallySteps.length,
      complete: false
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { SessionStore } = this.props.store;
    const { loadingCalls, failedCalls, tallyConfirmClose } = SessionStore;
    const { steps } = this.state;
    const updatedSteps = [];
    let total = steps.length;
    let completed = 0;

    if(prevState.steps === this.state.steps) {
      steps.forEach(step => {
        // Mark newly started steps
        if(!step.started && loadingCalls.indexOf(step.title) > -1) {
          step.started = true;
        }

        // Mark failed steps
        if (step.started && loadingCalls.indexOf(step.title) < 0 && failedCalls.indexOf(step.title) > -1) {
          step.completed = true;
          completed++;
        }

        // Mark off completed steps
        if(step.started && loadingCalls.indexOf(step.title) < 0 && failedCalls.indexOf(step.title) < 0) {
          step.success = true;
          step.completed = true;
          completed++;
        }

        updatedSteps.push(step)
      });

      this.setState({
        steps: updatedSteps
      });

      if(completed === total) {
        // Set a small timeout so the transition
        // from tally loader to next screen
        // isn’t as jarring
        if (!tallyConfirmClose) {
          setTimeout(function(){
            SessionStore.tallyLoad = false;
            SessionStore.tallySteps = [];
          }, 500);
        } else {
          const _this = this;
          setTimeout(function() {
            _this.setState({ complete: true });
          }, 500)
        }
      }
    }
  }

  componentWillUnmount() {
    const { SessionStore } = this.props.store;
    SessionStore.tallySteps = [];
    SessionStore.tallyLoad = false;
    SessionStore.failedCalls = [];
    SessionStore.tallyConfirmClose = false;
  }

  closeTally() {
    const _this = this;
    const { ExamStore, SessionStore } = this.props.store;

    // Clear out examFiles and examAttachments
    // since they have already been handled
    ExamStore.examAttachments = null;
    ExamStore.examFiles = null;

    SessionStore.tallyLoad = false;
    SessionStore.tallySteps = [];
    SessionStore.tallyConfirmClose = false;

      // Redirect
      let newPathname = '';
      const segment1 = getURLSegment(_this, 1);
      const segment2 = getURLSegment(_this, 2);


      if(segment2 === 'add') {
        newPathname = `${segment1}/${ExamStore.examSid}`;
      } else {
        const examSid = getURLSegment(_this, 3);
        newPathname = `${segment1}/${examSid}`;
      }

      _this.props.routing.push({
        pathname: newPathname,
        search: '?toaster=examSaved'
      });
  }

  render() {
    const _this = this;
    const { translation } = this.props;
    const { loadingCalls, failedCalls } = this.props.store.SessionStore;
    const { steps, complete } = this.state;

    return(
      <div className="panel--brief tally-loader">
        {!complete &&
          <ol className="tally">
            {steps.map(
              (step, i) =>
              {
                let status = '';
                let title = step.title;

                if(loadingCalls.indexOf(step.title) > -1 && !step.completed) {
                  status = 'in-progress';
                } else if(step.completed) {
                  if (step.success) {
                    status = 'completed';
                  } else {
                    status = 'failed';
                    title += '_failed';
                  }
                }

                return (
                  <li key={i}>
                    <strong className="tally__title">
                      {translation[title] || step.title}
                    </strong>

                    <span
                      className={`tally__status ${status}`}
                    >
                      <span className="meta">
                        {translation[status]}
                      </span>
                    </span>
                  </li>
                )
              }
            )}
          </ol>
        }

        {complete &&
          <div>
            {failedCalls.length > 0 &&
              <h2>{translation.exam_created.roster_fail}</h2>
            }

            {failedCalls.length === 0 &&
              <h2>{translation.exam_created.roster_success}</h2>
            }
            <button
              className='actions__btn actions__btn--primary'
              onClick={() => this.closeTally()}
            >
              {translation.confirm}
            </button>
          </div>
        }
      </div>
    );
  }
})

export default translate('TallyLoader')(TallyLoader);



// WEBPACK FOOTER //
// ./src/app/components/Common/TallyLoader.js